export enum MetadataProvider {
  Hardcover = 2,
  Mangabaka = 3,
  ComicBookRoundup = 4,
}

export const AllMetadataProviders: MetadataProvider[] = [
  MetadataProvider.Hardcover,
  MetadataProvider.Mangabaka,
  MetadataProvider.ComicBookRoundup,
];
